module.exports = __webpack_public_path__ + "components/home-header/static/header-6--small@2x-85f70a5f27cbb9073039e55800984d1d.jpg";